@if(item.link){
<a [routerLink]="item.link ? [item.link] : []" [queryParams]="item.query"
  class="flex items-center justify-between text-gray-900" >
  <div class="flex items-center relative" [ngClass]="{'!text-gray-900': !item.link}" [routerLinkActive]="['text-green-500']"
    [routerLinkActiveOptions]="{exact: true}">
    <!-- ? Icon -->
    <span class="icon text-xl" [ngClass]="item.icon"></span>

    <!-- ? Titale -->
    <span class="text-sm mr-2">
      {{ item.title }}
    </span>
    <span
      class="absolute bottom-2 left-[3.6rem] w-[17px] h-[17px] mr-2 rounded-full p-2 flex items-center justify-center text-white text-[0.65rem] text-center bg-red-700"
      *ngIf="notificationCount && item.type === 13">{{notificationCount}}</span>
  </div>


  <!-- ? Count -->
  <!-- <ng-container *ngIf="displayCount && item.count > 0">
    <span
      class=" mr-2 rounded-full text-sm  w-[17px] h-[17px] flex flex-wrap  content-center justify-center  bg-red-700 text-white">
      {{ item.count }}
    </span>
  </ng-container> -->
</a>
}@else {
<a class="flex items-center justify-between text-gray-900 cursor-pointer">
  <div class="flex items-center text-gray-900" [routerLinkActive]="['text-green-500']"
    [routerLinkActiveOptions]="{exact: true}">
    <!-- ? Icon -->
    <span class="icon text-xl" [ngClass]="item.icon"></span>

    <!-- ? Titale -->
    <span class="text-sm mr-2">
      {{ item.title }}
    </span>

  </div>
</a>
}